var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"grid-x",style:({height: _vm.banheight, backgroundColor: _vm.banbackcol})},[_c('div',{staticClass:"cell text-center"},[_c('div',{ref:"adContainer",domProps:{"innerHTML":_vm._s(_vm.banners[1].Html)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }